import { render, staticRenderFns } from "./DisplayAddress.vue?vue&type=template&id=20a85c4e&scoped=true&"
import script from "./DisplayAddress.vue?vue&type=script&lang=js&"
export * from "./DisplayAddress.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAddress.vue?vue&type=style&index=0&id=20a85c4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a85c4e",
  null
  
)

export default component.exports